import { render } from "./FrisoVideo.vue?vue&type=template&id=c21c9ee6"
import script from "./FrisoVideo.vue?vue&type=script&lang=js"
export * from "./FrisoVideo.vue?vue&type=script&lang=js"

import exportComponent from "/Users/gabrielvoirol/git_projects/df_wpheadless/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__